var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctBoolean, FctBytes32, FctValue, isVariable } from '../../../../Fct/generics';
import { getTokenDecimals } from '../../../../Fct/getSwapPath';
import { getAllCurrencies } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { getMethodName } from '../../../../Fct/plugins/uniswap/helpers/getMethodName';
import { getIsNative } from '../../../../Fct/plugins/uniswap/helpers/getToken';
import { fctUniswapContracts, method } from '../constants';
import { FaExchangeAlt } from 'react-icons/fa';
export var SimulateSwap = createPlugin({
    protocol: 'UNISWAP',
    type: 'GETTER',
    method: 'simulateSwap',
    supportedContracts: fctUniswapContracts,
    initParams: {
        isExactIn: 'true',
    },
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                addressIn: new FctAddress({ options: getAllCurrencies({ chainId: chainId }), isPreview: true, icon: FaExchangeAlt, }),
                amountIn: new FctValue({
                    destination: 'wei_amount',
                    isPreview: true,
                }),
                addressOut: new FctAddress({ options: getAllCurrencies({ chainId: chainId }), isPreview: true }),
                amountOut: new FctValue({
                    destination: 'wei_amount',
                }),
                isExactIn: new FctBoolean({}),
                methodParams: {
                    amount: new FctValue({ destination: 'wei_amount' }),
                    method: new FctBytes32({
                        messageType: 'string',
                        options: Object.keys(method).map(function (key) {
                            var methodKey = key;
                            return { name: key, value: method[methodKey] };
                        }),
                    }),
                    path: new FctAddressList({ destination: 'ERC20_List', options: getAllCurrencies({ chainId: chainId }) }),
                },
            },
            output: {
                amountIn: new FctValue({ innerIndex: 0, destination: 'wei_amount' }),
                amountOut: new FctValue({ innerIndex: 1, destination: 'wei_amount' }),
                tokenIn: new FctAddress({ innerIndex: 2, destination: 'erc20' }),
                tokenOut: new FctAddress({ innerIndex: -1, destination: 'erc20' }),
            },
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, provider = _a.provider;
        var getPathParams = function (_a) {
            var service = _a.service;
            return __awaiter(void 0, void 0, void 0, function () {
                var isExactIn, uniswapService, tokenInAddress, tokenOutAddress, defaultReturn, amount, decimalsIn, _b, decimalsOut, _c, isSimulationNeeded, res, swapPath, methodName, methodParamValue, e_1;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!service)
                                return [2 /*return*/];
                            isExactIn = input.isExactIn.value === 'true';
                            uniswapService = service;
                            tokenInAddress = input.addressIn.value;
                            tokenOutAddress = input.addressOut.value;
                            if (isExactIn) {
                                input.amountIn.readonly = false;
                                input.amountOut.readonly = true;
                            }
                            if (!isExactIn) {
                                input.amountIn.readonly = true;
                                input.amountOut.readonly = false;
                            }
                            defaultReturn = isExactIn
                                ? {
                                    params: {
                                        amountOut: undefined,
                                        methodParams: { path: undefined, method: undefined, amount: undefined },
                                    },
                                    error: undefined,
                                }
                                : {
                                    params: {
                                        amountIn: undefined,
                                        methodParams: { path: undefined, method: undefined, amount: undefined },
                                    },
                                    error: undefined,
                                };
                            if (!tokenInAddress ||
                                !tokenOutAddress ||
                                typeof tokenInAddress !== 'string' ||
                                typeof tokenOutAddress !== 'string')
                                return [2 /*return*/, defaultReturn];
                            amount = isExactIn ? input.amountIn.value : input.amountOut.value;
                            if (amount === undefined)
                                return [2 /*return*/, defaultReturn];
                            if (!provider) return [3 /*break*/, 2];
                            return [4 /*yield*/, getTokenDecimals({ address: tokenInAddress, provider: provider })];
                        case 1:
                            _b = _d.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            _b = 18;
                            _d.label = 3;
                        case 3:
                            decimalsIn = _b;
                            if (!provider) return [3 /*break*/, 5];
                            return [4 /*yield*/, getTokenDecimals({ address: tokenOutAddress, provider: provider })];
                        case 4:
                            _c = _d.sent();
                            return [3 /*break*/, 6];
                        case 5:
                            _c = 18;
                            _d.label = 6;
                        case 6:
                            decimalsOut = _c;
                            isSimulationNeeded = false;
                            if (!amount || isVariable(amount)) {
                                isSimulationNeeded = true;
                                amount = '1' + '0'.repeat(isExactIn ? decimalsIn : decimalsOut);
                            }
                            _d.label = 7;
                        case 7:
                            _d.trys.push([7, 9, , 10]);
                            return [4 /*yield*/, uniswapService.create({
                                    cmd: 'simulateSwap',
                                    protocol: 'uniswap',
                                    token_in: tokenInAddress,
                                    token_in_decimals: decimalsIn,
                                    token_out: tokenOutAddress,
                                    token_out_decimals: decimalsOut,
                                    token_amount: amount,
                                    version: 'v2',
                                    type: isExactIn ? 'in' : 'out',
                                })];
                        case 8:
                            res = (_d.sent());
                            swapPath = res === null || res === void 0 ? void 0 : res.path;
                            if (!swapPath) {
                                return [2 /*return*/, {
                                        params: {
                                            amountIn: isExactIn ? amount : undefined,
                                            amountOut: isExactIn ? undefined : amount,
                                            methodParams: { path: undefined, amount: undefined, method: undefined },
                                        },
                                        error: 'invalid trade',
                                    }];
                            }
                            methodName = getMethodName({
                                isExactInput: isExactIn,
                                protocol: 'V2',
                                isInputNative: getIsNative(tokenInAddress),
                                isOutputNative: getIsNative(tokenOutAddress),
                            });
                            methodParamValue = method[methodName];
                            if (isExactIn) {
                                return [2 /*return*/, {
                                        params: {
                                            amountOut: res.outputAmount,
                                            methodParams: { path: swapPath, method: methodParamValue, amount: amount },
                                        },
                                        isSimulationNeeded: isSimulationNeeded,
                                        error: undefined,
                                    }];
                            }
                            return [2 /*return*/, {
                                    params: {
                                        amountIn: res.inputAmount,
                                        methodParams: { path: swapPath, method: methodParamValue, amount: amount },
                                    },
                                    isSimulationNeeded: isSimulationNeeded,
                                    error: undefined,
                                }];
                        case 9:
                            e_1 = _d.sent();
                            return [2 /*return*/, {
                                    params: {
                                        amountIn: isExactIn ? amount : undefined,
                                        amountOut: isExactIn ? undefined : amount,
                                        methodParams: { path: undefined, amount: undefined, method: undefined },
                                    },
                                    error: e_1.message,
                                }];
                        case 10: return [2 /*return*/];
                    }
                });
            });
        };
        var getDepParams = function () {
            var isExactIn = input.isExactIn.value === 'true';
            return isExactIn
                ? ['addressIn', 'addressOut', 'isExactIn', 'amountIn']
                : ['addressIn', 'addressOut', 'isExactIn', 'amountOut'];
        };
        return {
            get: getPathParams,
            depParamKeys: getDepParams,
        };
    },
    onCreate: function (_a) {
        var input = _a.input;
        var setAmountIn = function () {
            if (input.isExactIn.value !== 'true')
                return;
            input.methodParams.amount.set({ value: input.amountIn.value });
        };
        var setAmountOut = function () {
            if (input.isExactIn.value === 'true')
                return;
            input.methodParams.amount.set({ value: input.amountOut.value });
        };
        input.amountIn.subscribe({
            callback: function () {
                setAmountIn();
            },
            id: 'set amount by amountIn',
        });
        input.amountOut.subscribe({
            callback: function () {
                setAmountOut();
            },
            id: 'set amount by amountOut',
        });
        input.isExactIn.subscribe({
            callback: function (_a) {
                var value = _a.value;
                if (value === 'true') {
                    setAmountIn();
                }
                if (value === 'false') {
                    setAmountOut();
                }
            },
            id: 'set amount on isExactIn change',
        });
        setAmountIn();
        setAmountOut();
    },
});
